import { createSlatePlugin, TElement } from "platejs";
import { toNodeProps } from "./withNodeProps";

const CONTAINER_TAG_NAMES = [
  "DIV",
  "ARTICLE",
  "SECTION",
  "ASIDE",
  "HEADER",
  "FOOTER",
  "MAIN",
  "NAV",
  "FIGURE",
  "FIGCAPTION",
  "ADDRESS",
  "HGROUP",
];

export type TDivElement = TElement & { tagName?: keyof HTMLElementTagNameMap };

export const DivPlugin = createSlatePlugin({
  key: "div",
  node: {
    isElement: true,
    isContainer: true,
  },
  parsers: {
    html: {
      deserializer: {
        rules: [{ validNodeName: CONTAINER_TAG_NAMES }],
        parse: ({ element, type }) => ({
          type,
          tagName: element.tagName.toLowerCase(),
        }),
        toNodeProps: toNodeProps,
      },
    },
  },
});
